import React from 'react'
import { i18nText } from '../../../Services';

export const Link = props => {
    const { context, element, modelPath } = props;
    const inputModel = context.readModel(modelPath, element.defaultValue || "");    

    let text = i18nText.getText(element.text);
    text = text.length === 0 ? inputModel.value : text;

    return (
        <>
            {inputModel.value && 
                <a 
                    href={inputModel.value} 
                    target={element.target}
                    className={element.className}>
                    {text}
                </a>
            }
        </>
    )
}

export default Link;
